import React, { useState } from 'react';

import { ISimpleOptionSelect, spacingV2, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IOptionProps {
  className: string;
  option: ISimpleOptionSelect;
  onClick: (option: ISimpleOptionSelect) => void;
  style: React.CSSProperties;
}

export const Option = ({ className, option, onClick, style }: IOptionProps) => {
  const [isHovered, setIsHover] = useState(false);

  const getBackgoundColor = () => {
    if (option.isSelected) return publicaColors.veryLightGray;
    if (isHovered) return `${publicaColors.veryLightGray}80`; // 50% opacity
    return 'inherit';
  };

  return (
    <div
      onClick={() => onClick(option)}
      onMouseEnter={() => setIsHover(true)}
      onMouseOut={() => setIsHover(false)}
      style={{
        ...style,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        background: getBackgoundColor(),
        paddingLeft: spacingV2.small,
        pointerEvents: option.isDisabled ? 'none' : 'all',
      }}
      className={className}
    >
      {option.customComponent || (
        <Text
          small
          muted={option.isDisabled}
          bold={option.isSelected}
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {option.label}
        </Text>
      )}
    </div>
  );
};
